import React from 'react';
import { Typography, Grid } from '@mui/material';
import ReactInputMask from 'react-input-mask';
import { styled } from "@mui/system";
import Alert from '@mui/material/Alert';

const StyledInput = styled(ReactInputMask)({
    '::placeholder': {
        color: '#dddddd'
    }
});

function CreatingAccount({ handleChangeAccount, formValues, activeErrorPassword, errorPassword, validateErrosPassword, errorGeneric, activeValidEmail,
    validEmail,
    validarEmail }) {

    const handleBlur = (event) => {
        if (event.target.name == 'passwordConfirm') {
            validateErrosPassword()
        }
        if (event.target.name == 'email') {
            validarEmail(event.target.value)
        }
    }

    return (
        <Grid style={styles.container}>
            <Grid>
                <Typography variant="h4" style={styles.title}>
                    É fácil e rápido!
                </Typography>
                <Typography variant="h6" style={styles.subTitle}>
                    Informe os seus dados preenchendo os campos abaixo.
                </Typography>
            </Grid>
            <Grid style={styles.gridInput} justifyContent="flex-start">
                <Grid container spacing={2}>
                    {formValues.map(i => (
                        <Grid item xs={6} sx={{ padding: '30px' }}>
                            <Typography style={styles.titleInput} color={i.config.value ? 'gray' : 'black'}>{i.config.label}</Typography>
                            <StyledInput
                                mask={i.config.mask}
                                variant="outlined"
                                type={i.config.type}
                                style={styles.input}
                                required
                                id={i.config.id}
                                name={i.config.name}
                                placeholder={i.config.label}
                                placeholderTextColor="#dddddd"
                                value={i.config.value}
                                onChange={handleChangeAccount}
                                onBlur={handleBlur}
                            />
                        </Grid>
                    ))}
                </Grid>
                {activeErrorPassword ? (
                    < Alert severity="warning">{errorPassword}</Alert>
                ) : (
                    errorGeneric == 'O e-mail informado já está cadastrado. Utilize a página de login para acessar sua empresa ou entre em contato com o nosso suporte.' ? (
                        < Alert severity="warning">
                            <Typography> O e-mail informado já está cadastrado. Utilize a página de <a href='https://app.puntu.com.br/'>login</a> para acessar sua empresa ou entre em contato com o nosso <a href="https://api.whatsapp.com/send/?phone=5561996894936&text&type=phone_number&app_absent=0">suporte</a>.</Typography>
                        </Alert>
                    ) : (
                        ''
                    )
                )
                }
                {activeValidEmail ? < Alert severity="warning">{validEmail}</Alert> : ''}
            </Grid>
        </Grid >
    )
}

export default CreatingAccount;

const styles = ({
    container: {
        justifyContent: 'flex-start',
        display: 'flex',
        padding: 50,
        flexDirection: 'column'
    },
    title: {
        fontFamily: 'Montserrat',
        textAlign: 'left',
        fontWeight: 500,
        fontSize: '30px'
    },
    subTitle: {
        fontFamily: 'Montserrat',
        textAlign: 'left',
        fontWeight: 500,
        fontSize: '15px'
    },
    gridInput: {
        paddingTop: 60
    },
    titleInput: {
        textAlign: 'start',
        fontFamily: 'montserrat',
        fontSize: '12px',
        fontWeight: 'bold'
    },
    input: {
        width: '100%',
        border: "none",
        outline: "none",
        padding: '0px',
        fontFamily: 'Montserrat',
        fontSize: '16px',
        fontWeight: '600',
        height: '20px',
        '::placeholder': { color: '#FFFFF' }
    }
})